import { Button } from '@/components/ui/button';
import { useAxios } from '@/hooks/useAxios';
import { RocketIcon } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

export const GithubInstructions = () => {
  const axios = useAxios();
  const [starting, setStarting] = useState(false);

  // ENG-3327: never link to the bare GitHub install URL — that path
  // produces an unauthenticated callback our backend now rejects.
  // Hit /integration/github/start to get an install URL with a
  // signed `state` parameter bound to the current tenant + user.
  const startInstall = async () => {
    setStarting(true);
    try {
      const { data } = await axios.get<{ url: string }>(
        '/integration/github/start'
      );
      window.document.location = data.url;
    } catch (err) {
      toast.error('Could not start GitHub install', {
        description:
          err instanceof Error ? err.message : 'Please try again shortly.',
      });
      setStarting(false);
    }
  };

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot GitHub App in your organization:
      </p>
      <div>
        <Button
          onClick={startInstall}
          disabled={starting}
          className="rounded-xs p-1!"
        ><RocketIcon />{starting ? 'Starting…' : 'Install GitHub App'}</Button>
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};

export const BitbucketAuthInstructions = () => {
  const url = 'https://bitbucket.org/install-chariot';

  return (
    <div>
      <p className="mb-4 block text-sm leading-6">
        Install the Chariot Bitbucket App in your organization:
      </p>
      <div>
        <Button
          onClick={() => {
            window.document.location = url;
          }}
          className="rounded-xs"
        ><RocketIcon />Install Bitbucket App</Button>
      </div>
      <div className="relative mt-4">
        <span className="bg-chariot-background-primary text-chariot-text-primary sticky left-[200px] z-10 px-4">
          OR
        </span>
        <hr className="border-chariot-stroke absolute top-3 w-full" />
        <p className="mb-4 block text-sm leading-6">
          Provide a Workspace access token and your organization name
        </p>
      </div>
    </div>
  );
};
